import React, { useState } from 'react';
import ResetPasswordComponent from './reset-password.component';

function ResetPassword() {
    const [snackbar, setShowSnackbar] = useState(true);
    return <ResetPasswordComponent snackbar={snackbar} setShowSnackbar={setShowSnackbar} />;
}

export default ResetPassword;
